import { previousItem, previousItemOutlined } from "./navigationMarkup";
export var getPreviousItemMarkup = function getPreviousItemMarkup(isShowingPageNumbers) {
  return isShowingPageNumbers ? previousItemOutlined : previousItem;
};